import React from 'react';
//import Spinner from 'react-spinkit';

import { Avatar, Box, IconButton } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

import { pink } from '@mui/material/colors';

function YoutubeBlockView({idx, block, allowEditing, onEdit}) {
	//console.log("YoutubeBlockView: allowEditing = " + allowEditing);
	//console.log("YoutubeBlockView: block.type = " + block.type);

	const [isLoading,setIsLoading] = React.useState(true);

	if (!block.data) return null;

	function handleIframeLoad(e) {
		setIsLoading(false);
	}

	function getEditButton() {
		if (allowEditing) {
			return (
				<IconButton
					style={{
						position:"absolute",
						top:20,
						left:20,
					}}
					size="large"
					onClick={e => onEdit(block)}
				>
					<Avatar sx={{bgcolor:pink[500]}}>
						<EditIcon />
					</Avatar>
				</IconButton>
			);
		}
		return null;
	}

	const iframeStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		borderWidth: 0,
		//border:'2px solid yellow',
		transform: `translateX(${block.translationX}%) scale(${block.scale})`,
	};

	return (
		<div
			style={{
				width:'100%',
				paddingTop:'56.25%',	// 16:9 aspect ratio
				backgroundColor: block.backgroundColor,
				//border:'2px solid red',
				overflow: 'hidden',
				position: 'relative',
			}}
		>
			{
				isLoading &&
				<div
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						background: 'url(images/Spinner-1s-200px.svg) center no-repeat #000',
						transform: `translateX(${block.translationX}%) scale(${block.scale})`,
					}}
				/>
			}
			<iframe
				id={block.name}
				style={iframeStyle}
				src={`https://www.youtube.com/embed/${block.data}`}
				frameBorder="0"
				allowFullScreen
				onLoad={handleIframeLoad}
			/>
			{getEditButton()}
		</div>
	);
/*
	return (
		<div
			style={{
				width:'100%',
				backgroundColor: block.backgroundColor,
				overflow:'hidden',
				position:'relative',
			}}
		>
			<div id={block.name} style={style}>
				<iframe
					style={{
						width:"100%",
						objectFit:"contain"
					}}
					src="https://www.youtube.com/embed/KDRt8QxnN1Q"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
					allowfullscreen
				/>
			</div>
			{getEditButton()}
		</div>
	);
*/
}

export default YoutubeBlockView;
